import { omit } from 'ramda'

/**
 * Comments vuex module actions factory.
 *
 * @param {FetchPath} fetchPath
 * @return {Object}
 */
export default ({ fetchPath }) => ({
  /**
   * saves a comment for a basket.
   *
   * @param {Function} dispatch
   * @param {Object} basket
   * @param {String} comment
   * @return {Promise}
   */
  xhrSaveCommentForBasket({ dispatch }, { basket, comment }) {
    return dispatch('_xhrSaveComment', { body: comment, basket: basket.iri, id: basket.comment })
  },

  /**
   * saves a comment for a basket.
   *
   * @param {Function} dispatch
   * @param {Object} basketLine
   * @param {String} comment
   * @return {Promise}
   */
  xhrSaveCommentForBasketLine({ dispatch }, { basketLine, comment }) {
    return dispatch('_xhrSaveComment', { body: comment, basketLine: basketLine.iri, id: basketLine.comment })
  },

  /**
   * Core, internal save comment function.
   *
   * Please call either saveCommentForBasket or saveCommentForBasketLine methods instead.
   *
   * @param {Function} dispatch
   * @param {Object} payload
   * @return {Promise}
   * @private
   */
  // eslint-disable-next-line no-underscore-dangle
  async _xhrSaveComment({ dispatch }, payload) {
    const { id } = payload
    let method = 'POST'
    let path = '/yoda/api/comments'
    let data = omit(['id'], payload)

    if (id) {
      method = 'PUT'
      path = `/yoda${id}`
      data = omit(['basket', 'basketLine'], data)
    }

    const response = await fetchPath.run({ path, method, data }).catch((e) => {
      dispatch('notifications/flash/create', {
        type: 'error',
        content: e.message,
      }, { root: true })
      throw e
    })

    dispatch('notifications/flash/create', {
      type: 'success',
      content: 'Comment saved.',
    }, { root: true })

    return response
  },
})
